import App from './component/App';
import Tidings from './Tidings/Tidings';

new App(new Tidings());


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/index.ts